import { VerticalLayoutFactory } from "@routes/Section/layouts/Verticals/utils/helpers";
import { VerticalsSectionPageData } from "@routes/Section/utils/types";

/** The vertical page content separated by vertical. */
const VerticalsPageContent = (
  data: VerticalsSectionPageData
): React.ReactElement => {
  const VerticalLayout = VerticalLayoutFactory(data.vertical);

  if (typeof VerticalLayout === "undefined") return <></>;

  return <VerticalLayout {...data} />;
};

export default VerticalsPageContent;
